import React from 'react'

import { useSpring, animated } from 'react-spring'
import { numberWithCommas } from './utils'

export default function AnimatedBalance({ num }) {
  const props = useSpring({
    number: num,
    from: { number: 0 },
    config: {
      duration: 400,
      easing: t => --t * t * t + 1,
    },
  })

  return (
    <animated.span>
      {
        props.number.interpolate(n =>
          numberWithCommas(Math.floor(n))
        ) /* innerText interpolation ... */
      }
    </animated.span>
  )
}
